import { put, call } from "redux-saga/effects";
import * as actions from "../actions";
import * as Api from "../../api";

// eslint-disable-next-line import/prefer-default-export
export function* requestPayslipsData() {
  yield put(actions.payslipsSetIsLoading(true));
  try {
    const response = yield call(Api.getPayslips);
    if (response.status === 200) {
      if (typeof response.data === "string") {
        yield put(actions.addError("payslips", response.data));
      }
      // eslint-disable-next-line
      const {
        payslips,
        hasP45,
        hasP60_2022,
        hasP60_2023,
        hasP60_2024,
        hasP60_2025,
      } = response.data;
      yield put(
        actions.payslipsSetData({
          payslips,
          hasP45,
          hasP60_2022,
          hasP60_2023,
          hasP60_2024,
          hasP60_2025,
        })
      );
    }
  } catch (err) {
    yield put(actions.addError("payslips", err));
  } finally {
    yield put(actions.payslipsSetIsLoading(false));
  }
}
